// removed by extract-text-webpack-plugin
module.exports = {"appCard":"Project__appCard__2iZJD","cardFlowIn":"Project__cardFlowIn__JnUN8","appCardCommerical":"Project__appCardCommerical__Bm07R","appHeading":"Project__appHeading__f3_kA","appCardTitle":"Project__appCardTitle__yShyf","appCardBody":"Project__appCardBody__1AZAY","appCardFooter":"Project__appCardFooter__15G4G"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Project/Project.css
// module id = 298
// module chunks = 0